import { createSignal, onCleanup, onMount } from "solid-js";
import type { VideoEvidence } from "../ChatEventTypes";

export const VIDEO_EVIDENCE_EVENT = "video_evidence";

export type VideoEvidenceEventDetail = {
	type: typeof VIDEO_EVIDENCE_EVENT;
	content?: {
		is_open: boolean;
		video_index: number;
		video_evidence: VideoEvidence[];
	};
};

type Options = {
	/** Called as clips are opened, before they are shown. */
	onOpen?: () => void;
};

/**
 * Listens for `chatevent` with {@link VIDEO_EVIDENCE_EVENT} and holds the clips
 * last opened, and which of them to start at.
 */
export function useVideoEvidencePanel(options: Options = {}) {
	const [opened, setOpened] = createSignal<{
		index: number;
		clips: VideoEvidence[];
	}>();

	onMount(() => {
		const onChatEvent = (evt: Event) => {
			const e = evt as CustomEvent<VideoEvidenceEventDetail>;
			if (
				e.detail?.type !== VIDEO_EVIDENCE_EVENT ||
				!e.detail.content?.is_open
			) {
				return;
			}
			options.onOpen?.();
			setOpened({
				index: e.detail.content.video_index,
				clips: e.detail.content.video_evidence,
			});
		};
		document.addEventListener("chatevent", onChatEvent);
		onCleanup(() => document.removeEventListener("chatevent", onChatEvent));
	});

	return {
		opened,
		close: () => setOpened(undefined),
	};
}
